<template>
  <div class="info-box">
    <div class="flex-1 overflow-y-auto gap-x-3">
      <el-form
        :model="state.model"
        label-width="auto"
        label-position="top"
        ref="formDom"
        size="large"
        class="overflow-y-auto px-2.5"
      >
        <el-form-item label="状态">
          <el-switch
            v-model="state.model.status"
            active-text="启用"
            inactive-text="禁用"
            inline-prompt
            :active-value="1"
            :inactive-value="0"
          />
        </el-form-item>
        <ul class="grid gap-x-5" style="grid-template-columns: 4.78fr 2fr 3fr">
          <el-form-item
            label="客户名称"
            prop="name"
            :rules="[
              { required: true, message: '请输入客户名称', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="客户性质"
            prop="d_customer_type_id"
            :rules="[
              { required: true, message: '请选择客户性质', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_customer_type_id">
              <el-option
                v-for="item in state.xz_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadXz"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item
            label="所属行业"
            prop="d_industry_id"
            :rules="[
              { required: true, message: '请选择所属行业', trigger: 'blur' },
            ]"
          >
            <el-select v-model="state.model.d_industry_id">
              <el-option
                v-for="item in state.hy_data"
                :key="item"
                :label="item.name"
                :value="item.id"
              ></el-option>
              <template #footer>
                <el-button
                  plain
                  class="float-right mb-3"
                  size="small"
                  @click="onLoadHy"
                >
                  刷新
                </el-button>
              </template>
            </el-select>
          </el-form-item>
        </ul>
        <ul class="grid gap-x-5" style="grid-template-columns: 3.13fr auto 5fr">
          <el-form-item
            label="联系人"
            prop="contact_name"
            :rules="[
              { required: true, message: '请输入联系人', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.contact_name"></el-input>
          </el-form-item>
          <el-form-item
            label="称谓"
            prop="contact_title"
            :rules="[
              { required: true, message: '请选择称谓', trigger: 'blur' },
            ]"
          >
            <div
              class="rounded px-3 cursor-pointer"
              :class="
                state.model.contact_title == '先生'
                  ? ' bg-green-800 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.contact_title = '先生'"
            >
              先生
            </div>
            <div
              class="rounded px-3 ml-2 cursor-pointer"
              :class="
                state.model.contact_title == '女士'
                  ? ' bg-red-600 text-white'
                  : ' text-gray-400 border'
              "
              @click="state.model.contact_title = '女士'"
            >
              女士
            </div>
          </el-form-item>
          <el-form-item
            label="联系人电话"
            prop="contact_phone"
            :rules="[
              { required: true, message: '请输入联系人电话', trigger: 'blur' },
              { validator: $phone_rules, trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.contact_phone"></el-input>
          </el-form-item>
        </ul>
        <ul class="grid grid-cols-3 gap-x-5">
          <el-form-item label="联系人职务" class="min-w-0">
            <el-input v-model="state.model.contact_job"></el-input>
          </el-form-item>
          <el-form-item
            label="联系人邮箱"
            prop="contact_email"
            :rules="[{ validator: $email_rules, trigger: 'blur' }]"
          >
            <el-input v-model="state.model.contact_email"></el-input>
          </el-form-item>
          <el-form-item label="联系人微信">
            <el-input v-model="state.model.contact_wechat"></el-input>
          </el-form-item>
        </ul>
        <el-form-item label="详细地址">
          <el-input v-model="state.model.address" type="textarea"></el-input>
        </el-form-item>
        <el-form-item
          label="负责人"
          prop="belonger_id"
          :rules="[
            { required: true, message: '请选择负责人', trigger: 'blur' },
          ]"
        >
          <c_userselect
            v-model="state.model.belonger_id"
            @change:item="
              (item) => {
                state.model.belonger_department_id = item.department_id;
              }
            "
          />
        </el-form-item>
        <el-form-item label="备注">
          <el-input v-model="state.model.remark" type="textarea"></el-input>
        </el-form-item>
      </el-form>
    </div>
    <div class="submit-box px-2.5">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </div>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { dic_getCustomerType, dic_getIndustry } from "@/http/data";
import { customer_detail, customer_add, customer_edit } from "@/http/customer";
import { post_response } from "@/utils/funcs";

export default {
  props: {
    id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: { status: 1 },
    });
    onMounted(() => {
      onLoadXz();
      onLoadHy();

      if (props.id) {
        customer_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data?.data || {};
          }
        });
      }
    });

    //获取客户性质
    const onLoadXz = () => {
      dic_getCustomerType().then((res) => {
        if (res.status == 200) {
          state.xz_data = res.data?.data || [];
        }
      });
    };

    //获取行业
    const onLoadHy = () => {
      dic_getIndustry().then((res) => {
        if (res.status == 200) {
          state.hy_data = res.data?.data || [];
        }
      });
    };

    const onSubmit = () => {
      formDom.value.validate((valid) => {
        if (valid) {
          if (props.id) {
            customer_edit(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          } else {
            customer_add(state.model).then((res) => {
              post_response(res, () => {
                setTimeout(() => {
                  emit("close", true);
                }, 500);
              });
            });
          }
        }
      });
    };

    return {
      state,
      props,
      formDom,
      onLoadXz,
      onLoadHy,
      onSubmit,
    };
  },
};
</script>
<style scoped></style>
